import * as React from 'react';
import { CourseProps } from 'Jsx/Shared/CourseCardV3/types';
import useMe from 'Jsx/Shared/Hooks/useMe';
import CourseCardV3Wrapper from './CourseCardV3Wrapper';
import CustomWrapper from '../utils/CustomWrapper';
import {
  Wrapper,
  Image,
  // Affiliate,
  Tag,
  CardBody,
  Title,
  Enrollments,
  Professor,
  Prices,
  AddToCart,
  AddToPack,
  AddToCartMobile,
  BrasilianTag,
} from '../components';

const CourseCardV3Full: React.FC<CourseProps> = ({
  title,
  url,
  metaDescription,
  affiliateCommission,
  affiliateUrl,
  dark,
  duration,
  enrollments,
  hideWishList,
  imagePlaceholder,
  isEnrollment,
  level,
  hidePreview,
  showOnlyAddToCardButton,
  prices,
  promoImage,
  promoImageAnimated,
  styles,
  urlToBuyNow,
  validateAddCustomBundle,
  courseInPack,
  originalId,
  professor,
  preSale,
  promoVideoHashedId,
  promoVideoProvider,
  trailerSource,
  customBundle,
  courseType,
  clickTitleHandler,
  lazyImageProps,
  categoryObj,
  principalSoftware,
  principalSoftwareObj,
  courseTag,
  imgxParams,
  wishedCourseActive,
  shoppingCartAdded,
  urlToAddToCart,
  score,
  description,
  enrollmentUrl,
  enrollmentAccessPreviewUrl,
  audio,
  subtitle,
  canEnroll,
  userLanguage,
  hidePreviewCTA,
  hideEnrollmentSection,
  wishlistMobile,
  isInSlider,
  courseCardPage,
  fullCustomBundle,
  // We must avoid using custom addToCart and removeFromCart functions.
  // Especial cases are for shopping cart and shopping cart pop up
  customInShoppingCart,
  customAddToCart,
  customRemoveFromCart,
  pageType,
  customToggleWishlistItem,
  onClickBuyNow,
  onClickEnrollNow,
  courses,
  showProfessor = true,
  classification,
  languageTag,
  lazyImage = true,
  showButtons = true,
  showPrice = true,
  isBundle = false,
  product,
  beforeBuy,
  beforePreview,
  showOnlyShoppingCartButton,
  showBuyNowButtonOnly,
  customOnClickImage,
  pageId,
  temporalAccessDurationLabel,
}) => {
  const showBrasilianTag = userLanguage === 'pt' && languageTag;
  const { me: user } = useMe();

  return (
    <CourseCardV3Wrapper
      canEnroll={canEnroll}
      audio={audio}
      subtitle={subtitle}
      title={title}
      metaDescription={metaDescription}
      url={url}
      affiliateCommission={affiliateCommission}
      affiliateUrl={affiliateUrl}
      courseInPack={courseInPack}
      dark={dark}
      duration={duration}
      enrollments={enrollments}
      hideWishList={hideWishList}
      showOnlyAddToCardButton={showOnlyAddToCardButton}
      imagePlaceholder={imagePlaceholder}
      isEnrollment={isEnrollment}
      level={level}
      professor={professor}
      preSale={preSale}
      promoVideoHashedId={promoVideoHashedId}
      promoVideoProvider={promoVideoProvider}
      trailerSource={trailerSource}
      hidePreview={hidePreview}
      prices={prices}
      promoImage={promoImage}
      promoImageAnimated={promoImageAnimated}
      styles={styles}
      urlToBuyNow={urlToBuyNow}
      user={user}
      validateAddCustomBundle={validateAddCustomBundle}
      originalId={originalId}
      courseType={courseType}
      principalSoftware={principalSoftware}
      principalSoftwareObj={principalSoftwareObj}
      courseTag={courseTag}
      imgxParams={imgxParams}
      clickTitleHandler={clickTitleHandler}
      lazyImageProps={lazyImageProps}
      lazyImage={lazyImage}
      categoryObj={categoryObj}
      wishedCourseActive={wishedCourseActive}
      enrollmentUrl={enrollmentUrl}
      enrollmentAccessPreviewUrl={enrollmentAccessPreviewUrl}
      score={score}
      description={description}
      customBundle={customBundle}
      urlToAddToCart={urlToAddToCart}
      shoppingCartAdded={shoppingCartAdded}
      customAddToCart={customAddToCart}
      customInShoppingCart={customInShoppingCart}
      customRemoveFromCart={customRemoveFromCart}
      wishlistMobile={wishlistMobile}
      userLanguage={userLanguage}
      hidePreviewCTA={hidePreviewCTA}
      isInSlider={isInSlider}
      courseCardPage={courseCardPage}
      fullCustomBundle={fullCustomBundle}
      pageType={pageType}
      pageId={pageId}
      customToggleWishlistItem={customToggleWishlistItem}
      onClickBuyNow={onClickBuyNow}
      onClickEnrollNow={onClickEnrollNow}
      bundleCoursesLength={courses ? courses.length : 0}
      showProfessor={showProfessor}
      classification={classification}
      languageTag={languageTag}
      product={product}
      beforeBuy={beforeBuy}
      beforePreview={beforePreview}
      isBundle={isBundle}
      showOnlyShoppingCartButton={showOnlyShoppingCartButton}
      showBuyNowButtonOnly={showBuyNowButtonOnly}
      customOnClickImage={customOnClickImage}
      temporalAccessDurationLabel={temporalAccessDurationLabel}
    >
      <Wrapper>
        <Tag />
        <Image>{showBrasilianTag && <BrasilianTag />}</Image>
        <CardBody>
          <Title />
          {showProfessor && <Professor />}
          {!hideEnrollmentSection && <Enrollments />}
          {showPrice && <Prices />}
          {showButtons &&
            !user?.hasOrganization &&
            (customBundle ? (
              <AddToPack />
            ) : (
              <CustomWrapper>
                <CustomWrapper className="hidden sm:block">
                  <AddToCart />
                </CustomWrapper>
                <CustomWrapper className="block sm:hidden">
                  <AddToCartMobile />
                </CustomWrapper>
              </CustomWrapper>
            ))}
        </CardBody>
      </Wrapper>
    </CourseCardV3Wrapper>
  );
};

export default CourseCardV3Full;
